module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_03_cpy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226319094_06_for#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("James Druckman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226319094_07_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226319094_08_int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Peter K. Hatemi and Rose McDermott")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226319094_09_ch01#ch1"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226319094_09_ch01#ch1"
    }
  }, [_vm._v("Evolution as a Theory for Political Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Peter K. Hatemi and Rose McDermott")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_10_ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_10_ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political Primates: What Other Primates Can Tell Us about the Evolutionary Roots of Our Own Political Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Darby Proctor and Sarah Brosnan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_11_ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_11_ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formal Evolutionary Modeling for Political Scientists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Oleg Smirnov and Tim Johnson")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_12_ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_12_ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modeling the Cultural and Biological Inheritance of Social and Political Behavior in Twins and Nuclear Families")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Lindon J. Eaves, Peter K. Hatemi, Andrew C. Heath, and Nicholas G. Martin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_13_ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_13_ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gene-Environment Interplay for the Study of Political Behaviors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Jason D. Boardman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_14_ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_14_ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genes, Games, and Political Participation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("James H. Fowler, Peter J. Loewen, Jaime Settle, and Christopher T. Dawes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_15_ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_15_ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mind-Body Connection: Psychophysiology as an Approach to Studying Political Attitudes and Behaviors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Kevin B. Smith and John R. Hibbing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_16_ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_16_ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hormones and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Rose McDermott")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226319094_17_ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_17_ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Testosterone and the Biology of Politics: Experimental Evidence from the 2008 Presidential Election")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Coren L. Apicella and David A. Cesarini")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From SCAN to Neuropolitics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Darren Schreiber")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_vm._v("Peter K. Hatemi and Rose McDermott")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226319094_20_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2598ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226319094_05_toc.vue
// module id = 69
// module chunks = 0